import React, { useRef, useState } from 'react';
import { taskHowTo } from '../shared/taskHelp';
import { pickNativeTaskPhoto } from '../utils/taskPhotoFile';

const PHOTO_ACCEPT = 'image/jpeg,image/png,image/heic,image/heif,.jpg,.jpeg,.png,.heic,.heif';

function pickerCancelled(error) {
  const message = String((error && error.message) || '');
  return /cancel/i.test(message);
}

function PhotoButton({ onPhoto, colors }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);
  const add = async () => {
    if (busy) return;
    setBusy(true);
    try {
      const nativeFile = await pickNativeTaskPhoto();
      if (nativeFile) {
        onPhoto(nativeFile);
        return;
      }
      if (inputRef.current) inputRef.current.click();
    } catch (error) {
      if (!pickerCancelled(error)) onPhoto(null);
    } finally {
      setBusy(false);
    }
  };
  return (
    <div style={{ marginTop: '0.75rem' }}>
      <button
        type="button"
        onClick={add}
        disabled={busy}
        style={{
          minHeight: '48px',
          width: '100%',
          borderRadius: '12px',
          border: `1px solid ${(colors && colors.border) || '#0f766e'}`,
          background: (colors && colors.surface) || '#fff',
          color: (colors && colors.text) || '#0f766e',
          fontWeight: 700,
          fontSize: '1rem',
          cursor: busy ? 'wait' : 'pointer',
        }}
      >
        {busy ? 'Opening photos...' : 'Add a photo'}
      </button>
      <input
        ref={inputRef}
        type="file"
        accept={PHOTO_ACCEPT}
        aria-label="Choose a completion photo"
        onChange={(event) => {
          const file = event.target.files && event.target.files[0];
          event.target.value = '';
          if (file) onPhoto(file);
        }}
        style={{ display: 'none' }}
      />
    </div>
  );
}

export default function TaskHelpCard({ task, home, vendorName, colors, readOnly, onHire, onPhoto }) {
  const help = taskHowTo(task, home);
  const ink = colors || {};
  const steps = help.steps || [];
  return (
    <div data-testid="task-help" style={{ marginTop: '0.9rem' }}>
      <p style={{ margin: '0 0 0.35rem', fontWeight: 700, color: ink.text }}>{help.effort}</p>
      <p style={{ margin: '0 0 0.75rem', color: ink.textSecondary }}>{help.time}</p>
      {steps.length ? (
        <>
          <h4 style={{ margin: '0 0 0.4rem', fontSize: '1rem', color: ink.text }}>How to</h4>
          <ol style={{ margin: '0 0 0.75rem', paddingLeft: '1.2rem', color: ink.textSecondary, lineHeight: 1.5 }}>
            {steps.map((step) => <li key={step}>{step}</li>)}
          </ol>
        </>
      ) : null}
      <p style={{ margin: '0 0 0.75rem', color: ink.textSecondary }}>Supplies: {help.supplies}</p>
      {!readOnly && vendorName && onHire ? (
        <button type="button" onClick={onHire} style={{ minHeight: 48, borderRadius: 12, border: 'none', background: '#0f766e', color: '#fff', fontWeight: 700, padding: '0.6rem 1rem' }}>
          Hire a Sponsor vendor
        </button>
      ) : null}
      {!readOnly && onPhoto ? <PhotoButton onPhoto={onPhoto} colors={ink} /> : null}
    </div>
  );
}
